/**
 * Page d'attente d'un écran maquetté (Lovable) dont le backend n'existe pas
 * encore. Dit franchement ce qui manque — jamais de fausses données présentées
 * comme réelles dans un back-office.
 */
import { Card, PageTitle, SectionLabel } from '../ui.tsx';

export function EnConstruction({ titre, note }: { titre: string; note: string }) {
  return (
    <>
      <PageTitle title={titre} />
      <Card>
        <SectionLabel>En construction</SectionLabel>
        <p className="mt-3 max-w-[560px] text-[15px] leading-relaxed text-fumee">{note}</p>
      </Card>
    </>
  );
}
